module.exports = __webpack_public_path__ + "img/app_store.b883e23f.png";